import { toaster } from "baseui/toast";
import { LabelMedium, ParagraphSmall, ParagraphXSmall } from "baseui/typography";
import { useEffect } from "react";
import { Check } from "baseui/icon";
import { SnackbarElementProps, useSnackbar } from "baseui/snackbar";
import { useIntl } from "react-intl";

function useReportMutationState(mutationResult: any, onSuccess?: () => void, successMessage?: SnackbarElementProps) {
  const { enqueue } = useSnackbar();
  const intl = useIntl();
  const defaultSuccessMessage = {
    message: intl.formatMessage({
      id: "Successfullyexecuted",
      defaultMessage: "Successfully executed",
    }),
    startEnhancer: ({ size }) => <Check size={size} />,
  };

  const sMessage = successMessage ?? defaultSuccessMessage;

  useEffect(() => {
    if (mutationResult.isError) {
      console.error("useReportMutationState", mutationResult);
      const err: any = mutationResult.error;
      const httpstatus = err.originalStatus ?? err.status;
      const errMsg =
        (err?.data?.errorMessage ?? err?.data?.message ?? err?.data !== undefined) ? JSON.stringify(err.data) : "";
      toaster.negative(
        <>
          <LabelMedium color="white">
            {intl.formatMessage({
              id: "error",
              defaultMessage: "Error",
            })}
          </LabelMedium>
          <ParagraphSmall color="white" margin={0}>
            {errMsg}
          </ParagraphSmall>
          <ParagraphXSmall color="white" margin={0}>
            {HttpStatusCodesToString(httpstatus)}
          </ParagraphXSmall>
        </>,
        {
          autoHideDuration: 7000,
          overrides: {
            Body: {
              style: ({ $theme }) => ({
                width: "auto",
              }),
            },
          },
        }
      );
    }

    if (mutationResult.isSuccess) {
      if (onSuccess) onSuccess();

      if (sMessage) enqueue(sMessage);
    }
  }, [mutationResult]);
}

export default useReportMutationState;

export const HttpStatusCodes = {
  "200": "OK",
  "201": "Created",
  "202": "Accepted",
  "203": "Non-Authoritative Information",
  "204": "No Content",
  "205": "Reset Content",
  "206": "Partial Content",
  "300": "Multiple Choices",
  "301": "Moved Permanently",
  "302": "Found",
  "303": "See Other",
  "304": "Not Modified",
  "305": "Use Proxy",
  "306": "Unused",
  "307": "Temporary Redirect",
  "400": "Bad Request",
  "401": "Unauthorized",
  "402": "Payment Required",
  "403": "Forbidden",
  "404": "Not Found",
  "405": "Method Not Allowed",
  "406": "Not Acceptable",
  "407": "Proxy Authentication Required",
  "408": "Request Timeout",
  "409": "Conflict",
  "410": "Gone",
  "411": "Length Required",
  "412": "Precondition Required",
  "413": "Request Entry Too Large",
  "414": "Request-URI Too Long",
  "415": "Unsupported Media Type",
  "416": "Requested Range Not Satisfiable",
  "417": "Expectation Failed",
  "418": "I'm a teapot",
  "429": "Too Many Requests",
  "500": "Internal Server Error",
  "501": "Not Implemented",
  "502": "Bad Gateway",
  "503": "Service Unavailable",
  "504": "Gateway Timeout",
  "505": "HTTP Version Not Supported",
};

export function HttpStatusCodesToString(code: number) {
  return HttpStatusCodes[code];
}
